import { message } from 'antd';
import moment from 'moment';
import { useCookies } from 'react-cookie';

import { postVote } from 'utils/apis/campaigns';
import { useFetchConstant } from 'utils/hooks/general';
import { CAMPAIGN_HOST_AWARD_COOKIES_PREFIX } from 'utils/constants';

export const useGetVoteDetails = fbId => {
  const { originalSelection: votingTypes } = useFetchConstant('campaignVotingTypes');
  const [cookies, setCookie] = useCookies([CAMPAIGN_HOST_AWARD_COOKIES_PREFIX]);

  const votedHosts =
    (votingTypes.HOST &&
      cookies[CAMPAIGN_HOST_AWARD_COOKIES_PREFIX] &&
      cookies[CAMPAIGN_HOST_AWARD_COOKIES_PREFIX][fbId] &&
      cookies[CAMPAIGN_HOST_AWARD_COOKIES_PREFIX][fbId][votingTypes.HOST.code]) ||
    [];
  const votedUnits =
    (votingTypes.UNIT &&
      cookies[CAMPAIGN_HOST_AWARD_COOKIES_PREFIX] &&
      cookies[CAMPAIGN_HOST_AWARD_COOKIES_PREFIX][fbId] &&
      cookies[CAMPAIGN_HOST_AWARD_COOKIES_PREFIX][fbId][votingTypes.UNIT.code]) ||
    [];

  const saveAndSubmitVote = (type, currentItemId, fbUser) => {
    const presetErrMsg = `You've reached your vote limit for this ${type}.`;
    const expiryDateForCookies = moment()
      .add(1, 'days')
      .hours(0)
      .minutes(0)
      .seconds(0);
    const isItemVotedBefore = type === votingTypes.HOST.code ? votedHosts.includes(currentItemId) : votedUnits.includes(currentItemId);
    if (isItemVotedBefore) {
      message.warning(presetErrMsg);
    } else {
      if (type === votingTypes.HOST.code) {
        setCookie(
          CAMPAIGN_HOST_AWARD_COOKIES_PREFIX,
          {
            ...cookies[CAMPAIGN_HOST_AWARD_COOKIES_PREFIX],
            [fbId]: {
              ...(cookies[CAMPAIGN_HOST_AWARD_COOKIES_PREFIX] && cookies[CAMPAIGN_HOST_AWARD_COOKIES_PREFIX][fbId]),
              [votingTypes.HOST.code]: [...votedHosts, currentItemId]
            }
          },
          { expires: new Date(expiryDateForCookies.format()), path: '/' }
        );
      } else {
        setCookie(
          CAMPAIGN_HOST_AWARD_COOKIES_PREFIX,
          {
            ...cookies[CAMPAIGN_HOST_AWARD_COOKIES_PREFIX],
            [fbId]: {
              ...(cookies[CAMPAIGN_HOST_AWARD_COOKIES_PREFIX] && cookies[CAMPAIGN_HOST_AWARD_COOKIES_PREFIX][fbId]),
              [votingTypes.UNIT.code]: [...votedUnits, currentItemId]
            }
          },
          { expires: new Date(expiryDateForCookies.format()), path: '/' }
        );
      }

      const payload = {
        type,
        voteFor: currentItemId,
        voter: {
          fbUserId: fbUser.id,
          name: fbUser.name,
          email: fbUser.email
        }
      };

      postVote(payload).catch(err => {
        if (err.response && err.response.status && err.response.status === 400) {
          const errorMsg = (err.response.data && err.response.data.message) || presetErrMsg;
          message.warning(errorMsg);
        } else {
          removeVote(type, currentItemId);
          message.error('Oops! Something went wrong. Please try again later.');
        }
      });
    }
  };

  const removeVote = (type, currentItemId) => {
    const expiryDateForCookies = moment()
      .add(1, 'days')
      .hours(0)
      .minutes(0)
      .seconds(0);
    const isItemVotedBefore = type === votingTypes.HOST.code ? votedHosts.includes(currentItemId) : votedUnits.includes(currentItemId);
    if (isItemVotedBefore && cookies[CAMPAIGN_HOST_AWARD_COOKIES_PREFIX] && cookies[CAMPAIGN_HOST_AWARD_COOKIES_PREFIX][fbId]) {
      if (type === votingTypes.HOST.code) {
        setCookie(
          CAMPAIGN_HOST_AWARD_COOKIES_PREFIX,
          {
            ...cookies[CAMPAIGN_HOST_AWARD_COOKIES_PREFIX],
            [fbId]: {
              ...(cookies[CAMPAIGN_HOST_AWARD_COOKIES_PREFIX] && cookies[CAMPAIGN_HOST_AWARD_COOKIES_PREFIX][fbId]),
              [votingTypes.HOST.code]: votedHosts.filter(host => host !== currentItemId)
            }
          },
          { expires: new Date(expiryDateForCookies.format()), path: '/' }
        );
      } else {
        setCookie(
          CAMPAIGN_HOST_AWARD_COOKIES_PREFIX,
          {
            ...cookies[CAMPAIGN_HOST_AWARD_COOKIES_PREFIX],
            [fbId]: {
              ...(cookies[CAMPAIGN_HOST_AWARD_COOKIES_PREFIX] && cookies[CAMPAIGN_HOST_AWARD_COOKIES_PREFIX][fbId]),
              [votingTypes.UNIT.code]: votedUnits.filter(unit => unit !== currentItemId)
            }
          },
          { expires: new Date(expiryDateForCookies.format()), path: '/' }
        );
      }
    }
  };
  return { votedHosts, votedUnits, saveAndSubmitVote, removeVote };
};
